export const raceTextMap: Record<number, string> = {
  1: '不死族',
  2: '兽族',
  3: '穴居族',
  4: '元素族',
  5: '精灵族',
  6: '恶魔族',
  7: '妖精族',
  8: '泥泽族',
}
